import { useMemo } from 'react';
import { useTranslation } from '@hotjar/translations';
import { getTargetedDevices } from '../../../common/Wizard/common/targeting';
import type { TargetEntry } from '../../../common/Wizard/common/targeting';

export type TargetingDevices = { isValid: boolean; summaryText: string | string[] };

export const useTargetingDevices = (
  targeting: TargetEntry[] | undefined,
): TargetingDevices | undefined => {
  const { t } = useTranslation('feedback', { keyPrefix: 'survey-wizard-summary' });
  return useMemo(() => {
    if (targeting === undefined) return undefined;
    const rules = getTargetedDevices(targeting);
    if (rules.length === 0) return { isValid: false, summaryText: t('device-not-set') };
    const values = rules.map((value) => {
      // eslint-disable-next-line default-case
      switch (value.target.pattern) {
        case 'phone':
          return t('device-phone');
        case 'desktop':
          return t('device-desktop');
        case 'tablet':
          return t('device-tablet');
        default:
          throw new Error('Undefined device type');
      }
    });

    return { isValid: true, summaryText: values };
  }, [t, targeting]);
};
